<p-accordion>
    <p-accordion-panel *ngFor="let feature of features; let i = index" [value]="i">
        <p-accordion-header>
            {{feature.Title}}
        </p-accordion-header>
        <p-accordion-content>
        <label class="kuba-choice-label"><p-checkbox [(ngModel)]="feature.IsChecked" binary="true"
            (click)="onTabOpen(i, feature.IsChecked)"></p-checkbox><span>Select All</span></label>
        <div *ngIf="feature.Widgets || feature.AdditionFeatures">
            <ul *ngIf="feature.Widgets">
                <li *ngFor="let widget of feature.Widgets">
                    <input type="checkbox" [(ngModel)]="widget.IsChecked"> {{widget.Title}}
                </li>
            </ul>
            <ul *ngIf="feature.AdditionFeatures">
                <li *ngFor="let afeature of feature.AdditionFeatures">
                    <input type="checkbox" [(ngModel)]="afeature.IsChecked"> {{afeature.Title}}
                </li>
            </ul>
        </div>
        </p-accordion-content>
    </p-accordion-panel>
    <button (click)="saveFeatures(features)">Save</button>
</p-accordion>
